import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { endOfDay, formatISO, startOfDay } from 'date-fns';

const DEFAULT_PAGE_SIZE = 30;

export default class MyLocationsVisitorLogController extends Controller {
  queryParams = [
    'endDate',
    'locationIds',
    'pageNumber',
    'pageSize',
    'query',
    'signedOut',
    'sortBy',
    'sortDirection',
    'startDate',
  ];

  @tracked pageNumber = 1;
  @tracked pageSize = DEFAULT_PAGE_SIZE;
  @tracked startDate = formatISO(startOfDay(new Date()));
  @tracked endDate = formatISO(endOfDay(new Date()));
  @tracked locationIds? = '';
  @tracked signedOut?: string;
  @tracked query?: string;
  @tracked sortBy?: string;
  @tracked sortDirection?: string;

  @tracked loadingData = true;
}
